import React, { Component } from 'react';

// Import the CSS
import '../../scss/components/_tooltip.scss';

export default class Tooltip extends Component {
	handleMouseOut = () => {
		if (this.props.onMouseOut) {
			this.props.onMouseOut();
		}
	};

	handleMouseOver = () => {
		if (this.props.onMouseOver) {
			this.props.onMouseOver();
		}
	};

	render() {
		let wrapperClasses = ['tooltip-wrapper'];
		let classes = ['tooltip'];

		if (this.props.style) {
			wrapperClasses.push(`tooltip-${this.props.style}`);
		}

		if (this.props.position) {
			classes.push(`tooltip-${this.props.position}`);
		} else {
			classes.push('tooltip-top');
		}

		return (
			<div
				className={wrapperClasses.join(' ')}
				onMouseOver={this.handleMouseOver}
				onMouseOut={this.handleMouseOut}>
				{this.props.children}
				<div className={classes.join(' ')}>{this.props.text}</div>
			</div>
		);
	}
}

Tooltip.propTypes = {
	text: React.PropTypes.node,
	position: React.PropTypes.string,
	style: React.PropTypes.string,
	onMouseOver: React.PropTypes.func,
	onMouseOut: React.PropTypes.func,
	children: React.PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/assets/js/components/Tooltip.js